module.exports = __webpack_public_path__ + "img/1F974.7324f2d0.svg";